import { CSSProperties } from 'react';
import { LINE_HEIGHT } from './dynamicStyleConstants';
import { ISettingsFont } from '@wix/podcasts-common/dist/settings';

const FALLBACK_FONT = 'Avenir';

function fontToStyles(font: ISettingsFont) {
  return {
    fontFamily: `${font.family}, ${FALLBACK_FONT}`,
    fontSize: font.size,
    lineHeight: LINE_HEIGHT.DEFAULT,
    fontStyle: font.style && font.style.italic ? 'italic' : 'normal',
    fontWeight: font.style && font.style.bold ? 'bold' : 'normal',
    textDecoration: font.style && font.style.underline ? 'underline' : 'none',
  };
}

function getFontStyles(
  font: ISettingsFont,
  fontOverrides: Partial<CSSProperties> = {},
): any {
  if (!font) {
    return;
  }

  // NOTE: https://jira.wixpress.com/browse/POD-107
  return { ...fontToStyles(font), ...fontOverrides };
}

export default getFontStyles;
